export const buildMediaFileForImageConfig = (instance) => {
    let mediaFiles = {}
    if(instance?.logoMediaFile && instance.logoMediaFile.mediaFileUUID && instance.logoMediaFile.mediaFileUUID !== "") {
      mediaFiles.logoMediaFile = {
        liveLinks: instance.logoMediaFile.liveLinks,
        uuid: instance.logoMediaFile.uuid,
        mediaFileUUID: instance.logoMediaFile.mediaFileUUID,
        name: instance.logoMediaFile.name,
        fileFormat: instance.logoMediaFile.fileFormat,
      }
    }
    if(instance?.backgroundMediaFile && instance.backgroundMediaFile.mediaFileUUID && instance.backgroundMediaFile.mediaFileUUID !== "") {
      mediaFiles.backgroundMediaFile = {
        liveLinks: instance.backgroundMediaFile.liveLinks,
        uuid: instance.backgroundMediaFile.uuid,
        mediaFileUUID: instance.backgroundMediaFile.mediaFileUUID,
        name: instance.backgroundMediaFile.name,
        fileFormat: instance.backgroundMediaFile.fileFormat,
      }
    }
    return mediaFiles
}

